import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const NpawAdapterContext = createContext(void 0);
const NpawAdsAdapterContext = createContext(void 0);
function useNpawAdapter() {
  return useContext(NpawAdapterContext);
}
function useNpawAdsAdapter() {
  return useContext(NpawAdsAdapterContext);
}
function NpawAdapterProvider({
  adapter = void 0,
  adsAdapter = void 0,
  children = void 0
}) {
  return /* @__PURE__ */ jsx(NpawAdapterContext.Provider, { value: adapter, children: /* @__PURE__ */ jsx(NpawAdsAdapterContext.Provider, { value: adsAdapter, children }) });
}
NpawAdapterProvider.propTypes = {
  adapter: PropTypes.shape({}),
  adsAdapter: PropTypes.shape({}),
  children: PropTypes.node
};

export { NpawAdapterProvider, NpawAdapterContext as default, useNpawAdapter, useNpawAdsAdapter };
//# sourceMappingURL=NpawAdapterContext.js.map
